import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "取引中" },
  { value: 2, text: "取引停止" },
]);
